<template>
    <div class="dpp-buttons">
        <button v-if="!isActive" type="button" :aria-label="editText" class="link editview" @click="onEditClicked">
            <i class="icon-pencil"></i>
            <span>{{ editText }}</span>
        </button>
        <button v-else-if="photoCount>0"  type="button" aria-label="Photos" class="link photoview" :title="photoCount > 1 ?'Photos' : null" @click="onPhotoViewClicked">
            <i class="icon-image"></i><span>{{photoCount > 1 ? photoCount : 'Photos'}}</span>
        </button>

        <button type="button" :aria-label="mapPinText" class="link mapview" @click="onMapViewClicked">
            <i class="icon-pin"></i><span>{{ mapPinText }}</span>
        </button>
        <button type="button" :aria-label="shareText" class="link shareview" @click="onShareViewClicked">
            <i class="icon-share-ios"></i><span>{{ shareText }}</span>
        </button>
        <button type="button" :aria-label="favoriteText" @click.stop="onFavoriteClicked"  class="favorite link">
            <i :class="{ 'icon-heart active': isFavorite, 'icon-heart-o': !isFavorite }"></i><span>{{ favoriteText }}</span>
        </button>
        <mvtToastLinked v-if="!savedHomesCount" class="myTooltip"/>
    </div>
</template>

<script>
import mvtToastLinked from '@/common/components/mvttoastlinked/mvt-toastlinked.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'DppButtonPresentational',
    components: { mvtToastLinked },
    props: {
        isActive: Boolean,
        isMobile: Boolean,
        isFavorite: Boolean,
        photoCount: Number,
        savedHomesCount: Number,
        mapPinText: String,
        shareText: String,
        editText: String,
        favoriteText: String,
        onPhotoViewClicked: Function,
        onMapViewClicked: Function,
        onEditClicked: Function,
        onShareViewClicked: Function,
        onFavoriteClicked: Function,
    },
    computed: {
        ...mapGetters('glb', ['getSplit']),
    }
};
</script>

<style lang="scss">
@use './dpp-button.scss' as *;
</style>
